import { CustomError } from "../../Common";

type ConstructorArgs = {
  message: string;
  path?: string;
};

export default class UnauthorizedError extends CustomError {
  path?: string;

  constructor(args: ConstructorArgs) {
    super(args.message);
    this.path = args.path;
    this.name = "Unauthorized Error";

    if (this.path) this.addToTopOfStackTrace(`at Route: ${this.path}`);
  }
}
